import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagramSquare } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { FaWhatsappSquare } from "react-icons/fa";
import styles from "./bottom.module.css"
const BottomLink = () => {
  return (
    <>

      {/* <div className="fixed bottom-[35%] right-0 z-[35]">
        <nav className={styles.social}>
          <ul>
            <li>
              <p className="flex">
                <FaWhatsappSquare className="text-[25px] text-white" />
                <Link to="https://wa.me/971554812897"
                  target="_blank">
                  <span className="ml-3">Contact Us !</span>
                </Link>
              </p>
            </li>
            <li className="">
              <p className="flex">
                <FaWhatsappSquare className="text-[25px] text-white" />
                <Link
                  to="https://www.instagram.com/dewaapproval.ae?igsh=MWdya2RkdWY1MXdtaw=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ml-3">Stay Connected !</span>
                </Link>
              </p>
            </li>
            <li>
              <p className="flex">
                <FaFacebookF className="text-[25px] text-white" />

                <Link
                  to="https://www.facebook.com/share/1M43n9Xwgg/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="ml-3">Stay Connected !</span>
                </Link>
              </p>
            </li>
          </ul>
        </nav>
      </div> */}

      <div className="fixed bottom-[35%] right-0 z-[35]">
  <nav className={styles.social}>
    <ul>
      <li className="md:hover:scale-105 transition-transform">
        <a
          href="https://wa.me/971554812897"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center p-2"
        >
          <FaWhatsappSquare className="text-[25px] text-white" />
          <span className="ml-3 text-white">Contact Us !</span>
        </a>
      </li>

      <li className="md:hover:scale-105 transition-transform">
        <a
          href="https://www.instagram.com/dewaapproval.ae?igsh=MWdya2RkdWY1MXdtaw=="
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center p-2"
        >
          <FaInstagramSquare className="text-[25px] text-white" />
          <span className="ml-3 text-white">Stay Connected !</span>
        </a>
      </li>

      <li className="md:hover:scale-105 transition-transform">
        <a
          href="https://www.facebook.com/share/1M43n9Xwgg/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center p-2"
        >
          <FaFacebookF className="text-[25px] text-white" />
          <span className="ml-3 text-white">Stay Connected !</span>
        </a>
      </li>
    </ul>
  </nav>
</div>

    </>

  );
};

export default BottomLink;
